import { RouteConfig } from 'vue-router';
import DownloadCenter from './download-center.vue';

export const DownloadCenterRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'download-center',
  component: DownloadCenter,
};

export function getDefaultParams() {
  return {};
}

export default DownloadCenterRoute;
